import apiClient from './_axios';

/**
 * What each hardware type is CALLED and how it is shown.
 *
 * The dashboard used to hardcode a name and an emoji per board in three
 * places; this is the one list, edited on Admin Panel → WiFi settings. Every
 * screen that draws a device reads it and falls back to its own built-in when
 * the request has not answered yet, so a slow or failed load never leaves a
 * device card blank.
 */
export interface DeviceCatalogEntry {
   id: string;
   /** What to show. The admin's name, or the built-in one. */
   label: string;
   /** The built-in name, so an edit screen can offer "reset". */
   defaultLabel: string;
   /** Built-in glyph, used when there is no uploaded icon. */
   icon: string;
   /** Uploaded icon on our asset host; empty means use the glyph. */
   iconUrl: string;
   /** Firmware build target, where it differs from the id. */
   target: string;
   sortOrder: number;
}

export const getDeviceCatalog = async (): Promise<DeviceCatalogEntry[]> => {
   const r = await apiClient.get('/vendo/device-catalog');
   return r.data.devices as DeviceCatalogEntry[];
};

export const updateDeviceCatalogEntry = async (
   deviceId: string,
   patch: { label?: string; iconUrl?: string }
): Promise<DeviceCatalogEntry> => {
   const r = await apiClient.put(
      `/admin/device-catalog/${encodeURIComponent(deviceId)}`,
      patch
   );
   return r.data.device as DeviceCatalogEntry;
};

export const reorderDeviceCatalog = async (order: string[]): Promise<void> => {
   await apiClient.put('/admin/device-catalog/order', { order });
};

/** Presigned PUT for an icon, plus the public URL to save once it is uploaded. */
export const getDeviceIconUploadUrl = async (
   deviceId: string,
   input: { filename: string; size: number; contentType: string }
): Promise<{ uploadUrl: string; key: string; publicUrl: string }> => {
   const r = await apiClient.post(
      `/admin/device-catalog/${encodeURIComponent(deviceId)}/icon-url`,
      input
   );
   return r.data;
};
